import React from 'react';
import Slider from './SliderWrapper';
export default function ClientSay() {
    const testimonials = [
        {
            testimonial: "Outstanding design. They captured our vision with precision and efficiency. Highly satisfied!",
            name: "Mitali Sinha",
            imageSrc: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fsign-in%2Fsign-in3.png?alt=media&token=868147da-a385-42fb-9f6e-054cc9d2557e",
        },
        {
            testimonial: "Transformed our space beautifully. A seamless process from start to finish. Highly recommended.",
            name: "P. Gowda",
            imageSrc: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Ftestimonials%2Fp-gowda.jpeg?alt=media&token=cd8de94e-73a2-4a14-92c7-7b1e3ae79d48",
        },
        {
            testimonial: "They listened, they delivered. Impressed by their service.",
            name: "Nitin Prajapat",
            imageSrc: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Ftestimonials%2Fp-gowda.jpeg?alt=media&token=cd8de94e-73a2-4a14-92c7-7b1e3ae79d48",
        },
        {
            testimonial: "Fantastic architecture design & affordable.",
            name: "Snehal Raj",
            imageSrc: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Ftestimonials%2Fsnehal-raj.jpeg?alt=media&token=8937fcad-9cff-4196-9bde-9b114eea6990",
        },
    ];

    return (
        <div id='reviews' className="relative bg-gradient-to-r from-[#2c4557] to-[#2c4557] py-2">
            <img
                src="https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Farchitecture%2Fvector1.png?alt=media&token=79e7db4d-d183-4f4c-ac7e-5587c023adc0"
                alt="Vector"
                className="absolute w-[10%] left-0 z-10"
            />

            <div className='w-11/12 md:w-10/12 mx-auto my-6 flex items-center justify-center'>
                <h1 className='font-bold text-4xl md:text-3xl text-white text-center'>
                    What our Customer Says
                </h1>
            </div>

            <div className=' mx-auto overflow-hidden'>
                <Slider
                    interval={3000}
                    className=" p-2 rounded-lg bg-gradient-to-r from-transparent duration-500 transition-all"
                >
                    {testimonials.map((item, index) => (
                        <TestimonialCard
                            key={index}
                            testimonial={item.testimonial}
                            name={item.name}
                            imageSrc={item.imageSrc}
                        />
                    ))}
                </Slider>
            </div>

            <img
                src="https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Farchitecture%2Fvector2.png?alt=media&token=c30bb04d-a17f-4f43-bf6f-65994eaf2483"
                alt="Vector"
                className="w-[10%] absolute bottom-0 right-0 z-10 hidden md:block"
            />
        </div>
    );
}

const TestimonialCard = ({ testimonial, name, imageSrc }) => {
    return (
        <div className="mx-2 p-5 h-80  bg-white rounded-xl ">
              <div className="flex flex-col items-center justify-center my-4 gap-3">
                <img
                    src={imageSrc}
                    width={70}
                    height={70}
                    alt={name}
                    className="rounded-full border-2 border-[#7AD9BA]"
                />
                <h1 className="text-[#c4b819]  font-semibold text-xl">{name}</h1>
            </div>
            <p className=" text-wrap w-56 px-2 italic text-center  rounded-r-[50px] rounded-tl-[50px] text-black">
                {'"'+testimonial+'"'}
            </p>
          
        </div>
    );
};

